import React, {Component} from 'react';
import ReactDOM from 'react-dom';

import { ThemeProvider } from '@mui/material/styles';
import type { Theme} from '@mui/material/styles';

import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar'; 
// import Select from '@mui/material/Select';
//import { MenuItem } from '@mui/material/Menu';
//import TextField from '@mui/material/TextField';
//import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
//import Backdrop from '@mui/material/Backdrop';
//import Snackbar from '@mui/material/Snackbar';
//import Alert from '@mui/material/Alert';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import PersonIcon from '@mui/icons-material/Person';
import HelpIcon from '@mui/icons-material/Help';
// import {orange, grey, white} from '@mui/material/colors';
import MenuIcon from '@mui/icons-material/Menu'
import SecurityIcon from '@mui/icons-material/Security'
//import MUINotification from '../messages/MUINotification';
//import Alerts from '../messages/Alerts';
// import FormData from 'formdata-polyfill';
//import CenterGrid from '../layout/CenterGrid';
import {bizpost} from '../../ajax';
import ProgressDialog from '../dialogs/ProgressDialog';
//import { AlertTitle } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import FTextField from '../formfields/FTextField';
import FPasswordField from '../formfields/FPasswordField';
import FAutoComplete from '../formfields/FAutoComplete';
import { isValid } from '../form';
import LoginReset from './LoginReset';
import { Box } from '@mui/material';
import {
  Card,
  CardContent,
  TextField,

  CircularProgress,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";


// const orange500 = orange[500];
// const grey500 = grey[500];

//alert instance
//const alertx = new Alerts('login');

type Step = "CREDENTIALS" | "OTP_SELECT" | "OTP_VERIFY";
type OtpChannel = "EMAIL" | "SMS";

interface State {
  step: Step;
  email: string;
  password: string;
  otp: string;
  otpChannel: OtpChannel;
  loading: boolean;
  resendCountdown: number;
  passwordErrors: string[];
  regulatoryAccepted: boolean;
  reset:boolean;
}

interface PasswordPolicy {
  minLength: number;
  requireUppercase: boolean;
  requireLowercase: boolean;
  requireNumber: boolean;
  requireSpecialChar: boolean;
}

const PASSWORD_POLICY: PasswordPolicy = {
  minLength: 8,
  requireUppercase: true,
  requireLowercase: true,
  requireNumber: true,
  requireSpecialChar: true,
};

const s:any = {
  
  formbox: {
    backgroundColor:'#FFFFFF',
    borderRadius:'0 15px 15px 0',
    // marginRight: -15,
  },
  loginbar: {
    borderRadius:'0 15px 0 0',
    backgroundColor: 'secondary.main',
  },
  // loginbox: {
  //   //width: 450
  //   // margin:'50px auto',
  //   display: 'inline-block'
  // },
  loginform: {
    padding: 'spacing(1)',
    paddingLeft: 10,
    paddingRight: 10,
    width: 400,
  },
  xtoolbar: {
    display: "flex",
    justifyContent: "center",
    gap: 10,
  },
  titlebar: {
    // color: 'white',
    textAlign: 'center',
    flex:1
  },
  // formControl: {
  //   margin: 'spacing(1)',
  // },
  // input: {
  //   margin: 'spacing(1)',
  // },
  actionbox: {
    display: "flex",
    justifyContent: "center",
    gap: 10,
  },
  action: {
    margin: 'auto 5px',
  },
  linkbox: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  link: {
    margin: 'spacing(1)',
    textTransform: 'none',
  },
  // button: {
  //   margin: 'spacing(1)',
  // },
  leftIcon: {
    marginRight: 'spacing(1)',
  },
  // textField: {
  //   marginLeft: 'spacing(1)',
  //   marginRight: 'spacing(1)',
  //   //width: 200,
  // },
  // menu: {
  //   //width: 200,
  // },
  hide: {
    display:'none'
  },
  show: {
    display:'block'
  },
  logo: (theme:Theme)=>({
    cursor: 'pointer',
    fontSize: 22,
    color: 'common.white',
    fontWeight: 'typography.fontWeightLight',
    backgroundImage: 'url(lib/img/logo.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: '0 50%',
    backgroundColor: 'transparent',
    paddingLeft: 5,
    paddingRight: 5,
    height: 40,
    width: 40,
    [theme.breakpoints.down('sm')]:{
      display:'none',
    },
  }),
  first: {
    color: 'error.main', //'#FFC60B',
  },
  last: {
    color: 'common.white', // '#FFffFF', secondary.main
  }
};
  
class MFALoginForm extends Component<any,any> {
  timer?: NodeJS.Timeout;
  
    state: State = {
      step: "CREDENTIALS",
      email: "",
      password: "",
      otp: "",
      otpChannel: "EMAIL",
      loading: false,
      resendCountdown: 0,
      passwordErrors: [],
      regulatoryAccepted: false,
      reset:false
    };
  
    componentWillUnmount() {
      if (this.timer) clearInterval(this.timer);
    }
  
    startResendTimer = () => {
      this.setState({ resendCountdown: 60 });
  
      this.timer = setInterval(() => {
        this.setState((prev:any) => {
          if (prev.resendCountdown <= 1) {
            clearInterval(this.timer);
            return { resendCountdown: 0 };
          }
          return { resendCountdown: prev.resendCountdown - 1 };
        });
      }, 1000);
    };

    onReset = () => {
      this.setState({reset:true});
    };

    onExit = () => {
      //console.log('onexit called');
      this.setState({reset:false});
    };

    showNotification = (message:string,type:string,title:string) => {
      this.onError(type,title,message);
    };

    onError = (type:string,title:string,message:string) => {
      const {onMessage} = this.props;
      if(typeof onMessage === 'function') onMessage(type,title,message);
      else console.log('onMessage not a function... exiting...',(typeof onMessage));
    }
  
    handleCredentialSubmit = async() => {
      this.setState({ loading: true });
      try{
        // const {home,apptheme} = this.props;
        const {email, password }  = this.state;
        const json = {s:'security',a:'logon',unm:email,eml:email,pwd:password};
        
        const response = await bizpost(json);
        const {success,em,ed} = response;
        console.log('signin response ',(response||{}).success);
        if(!success){
          const err = ed || {};
          const {message="request failed. user not found",type='warn',title='Login Error'} = err;
          const {onMessage} = this.props;
          if(typeof onMessage === 'function') {onMessage(type,title,message);}
          else {alert(`Login Failed. ${em}`);}
        }
        else{
          this.setState({
            //loading: false,
            step: "OTP_SELECT",
          });
        }
      }
      catch(err){
        const error:any = err || {};
        console.log('login failed: ');
        const {message="request failed",type='warn',title='Login Error'} = error;
        //this.onError(type,title,message);
        const {onMessage} = this.props;
        if(typeof onMessage === 'function') {onMessage(type,title,message);}
        else {alert(`Login Failed. ${err}`);}
      }
      finally{
        this.setState({loading:false});
      }
  
      // // TODO: Validate credentials with backend
      // setTimeout(() => {
      //   this.setState({
      //     loading: false,
      //     step: "OTP_SELECT",
      //   });
      // }, 1200);
    };
  
    handleSendOtp = async() => {
      this.setState({ loading: true });

      try{
        // const {home,apptheme} = this.props;
        const {email, password,otpChannel }  = this.state;
        const json = {s:'security',a:'otp',unm:email,eml:email,chl:otpChannel};
        
        const response = await bizpost(json);
        const {success,em,ed} = response;
        console.log('otp response ',(response||{}).success);
        if(!success){
          const err = ed || {};
          const {message="OTP request failed",type='error',title='OTP Error'} = err;
          const {onMessage} = this.props;
          if(typeof onMessage === 'function') {onMessage(type,title,message);}
          else {alert(`Login Failed. ${em}`);}
        }
        else{
          this.setState({
            //loading: false,
            step: "OTP_VERIFY",
            otp: "",
          });
        }
      }
      catch(err){
        const error:any = err || {};
        console.log('otp failed: ');
        const {message="OTP request failed",type='error',title='OTP Error'} = error;
        //this.onError(type,title,message);
        const {onMessage} = this.props;
        if(typeof onMessage === 'function') {onMessage(type,title,message);}
        else {alert(`Request Failed. ${err}`);}
      }
      finally{
        this.setState({loading:false});
      }
  
      // // TODO: Backend call to send OTP (SMS or Email)
      // setTimeout(() => {
      //   this.setState({
      //     loading: false,
      //     step: "OTP_VERIFY",
      //     otp: "",
      //   });
      //   this.startResendTimer();
      // }, 1000);
    };
  
    handleVerifyOtp = async() => {
      const {home,apptheme} = this.props;
      this.setState({ loading: true });
      try{
        // const {home,apptheme} = this.props;
        const {otp}  = this.state;
        const json = {s:'security',a:'verify',otp:otp};
        
        const response = await bizpost(json);
        const {success,em,ed} = response;
        console.log('otp response success ',(response||{}).success);
        if(!success){
          const err = ed || {};
          const {message="OTP verification failed.",type='error',title='Verification Error'} = err;
          const {onMessage} = this.props;
          if(typeof onMessage === 'function') {onMessage(type,title,message);}
          else {alert(`Login Failed. ${em}`);}
        }
        else{
          ReactDOM.render(<ThemeProvider theme={apptheme}>{React.createElement(home,{udata:response})}</ThemeProvider>, document.getElementById('app'));
        }
      }
      catch(err){
        const error:any = err || {};
        console.log('login failed: ');
        const {message="OTP verification failed.",type='error',title='Verification Error'} = error;
        //this.onError(type,title,message);
        const {onMessage} = this.props;
        if(typeof onMessage === 'function') {onMessage(type,title,message);}
        else {alert(`Login Failed. ${err}`);}
      }
      finally{
        this.setState({loading:false});
      }
  
      // // TODO: Backend OTP verification
      // setTimeout(() => {
      //   this.setState({ loading: false });
      //   alert("Authenticated successfully");
      // }, 1200);
    };
  
    validatePassword = (password: string): string[] => {
      const errors: string[] = [];
  
      if (password.length < PASSWORD_POLICY.minLength) {
        errors.push(`At least ${PASSWORD_POLICY.minLength} characters`);
      }
      if (PASSWORD_POLICY.requireUppercase && !/[A-Z]/.test(password)) {
        errors.push("At least one uppercase letter");
      }
      if (PASSWORD_POLICY.requireLowercase && !/[a-z]/.test(password)) {
        errors.push("At least one lowercase letter");
      }
      if (PASSWORD_POLICY.requireNumber && !/[0-9]/.test(password)) {
        errors.push("At least one number");
      }
      if (
        PASSWORD_POLICY.requireSpecialChar &&
        !/[!@#$%^&*(),.?":{}|<>]/.test(password)
      ) {
        errors.push("At least one special character");
      }
  
      return errors;
    }
  
    renderCredentials0() {
      const { email, password, loading } = this.state;
  
      return (
        <>
          <TextField
            fullWidth
            label="Email or Username"
            margin="normal"
            value={email}
            onChange={(e) => this.setState({ email: e.target.value })}
          />
  
          <TextField
            fullWidth
            label="Password"
            type="password"
            margin="normal"
            value={password}
            onChange={(e) => this.setState({ password: e.target.value })}
          />
  
          <Button
            fullWidth
            variant="contained"
            size="large"
            sx={{ mt: 2 }}
            disabled={!email || !password || loading}
            onClick={this.handleCredentialSubmit}
          >
            {loading ? <CircularProgress size={24} /> : "Continue"}
          </Button>
        </>
      );
    }
    
    renderCredentials() {
      const { email, password, loading, passwordErrors, regulatoryAccepted,reset } =
        this.state;
  
      return (
        <>
          {this.renderRegulatoryBanner()}

          <LoginReset
            open={reset}
            //drag={drag}
            onClose={this.onExit}
            //onDrag={this.onDrag}
            showNotification={this.showNotification}
          />
  
          <TextField
            fullWidth
            label="Email or Username"
            margin="normal"
            value={email}
            onChange={(e) => this.setState({ email: e.target.value })}
            disabled={!regulatoryAccepted}
          />
  
          <TextField
            fullWidth
            label="Password"
            type="password"
            margin="normal"
            value={password}
            disabled={!regulatoryAccepted}
            onChange={(e) => {
              const pwd = e.target.value;
              this.setState({
                password: pwd,
                passwordErrors: this.validatePassword(pwd),
              });
            }}
          />

          <Button onClick={this.onReset}>
            <HelpIcon/>
            <Typography variant='body1'>Forgot Password?</Typography>
          </Button>
  
          {passwordErrors.length > 0 && (
            <Box sx={{ mt: 1 }}>
              {passwordErrors.map((err) => (
                <Typography key={err} variant="caption" color="error" display="block">
                  • {err}
                </Typography>
              ))}
            </Box>
          )}
  
          <Button
            fullWidth
            variant="contained"
            size="large"
            sx={{ mt: 2 }}
            disabled={
              !email ||
              !password ||
              passwordErrors.length > 0 ||
              loading ||
              !regulatoryAccepted
            }
            onClick={this.handleCredentialSubmit}
          >
            {loading ? <CircularProgress size={24} /> : "Continue"}
          </Button>
        </>
      );
    }
  
    renderOtpSelector() {
      const { otpChannel, loading } = this.state;
  
      return (
        <>
          <Typography textAlign="center" mb={2}>
            Select OTP delivery method
          </Typography>
  
          <ToggleButtonGroup
            fullWidth
            exclusive
            value={otpChannel}
            onChange={(_, value) =>
              value && this.setState({ otpChannel: value })
            }
            sx={{ mb: 2 }}
          >
            <ToggleButton value="EMAIL">Email</ToggleButton>
            <ToggleButton value="SMS">SMS</ToggleButton>
          </ToggleButtonGroup>
  
          <Button
            fullWidth
            variant="contained"
            size="large"
            disabled={loading}
            onClick={this.handleSendOtp}
          >
            {loading ? <CircularProgress size={24} /> : "Send OTP"}
          </Button>
  
          <Button
            fullWidth
            variant="text"
            sx={{ mt: 1 }}
            onClick={() => this.setState({ step: "CREDENTIALS" })}
          >
            Back
          </Button>
        </>
      );
    }
  
    renderOtpVerify() {
      const { otp, loading, resendCountdown, otpChannel } = this.state;
  
      return (
        <>
          <Typography variant="body2" textAlign="center" mb={2}>
            OTP sent via <strong>{otpChannel}</strong>
          </Typography>
  
          <TextField
            fullWidth
            label="One-Time Password"
            margin="normal"
            value={otp}
            onChange={(e) => this.setState({ otp: e.target.value })}
            inputProps={{
              maxLength: 6,
              style: { textAlign: "center", letterSpacing: "0.3em" },
            }}
          />
  
          <Button
            fullWidth
            variant="contained"
            size="large"
            sx={{ mt: 2 }}
            disabled={otp.length !== 6 || loading}
            onClick={this.handleVerifyOtp}
          >
            {loading ? <CircularProgress size={24} /> : "Verify & Login"}
          </Button>
  
          <Button
            fullWidth
            variant="text"
            sx={{ mt: 1 }}
            disabled={resendCountdown > 0}
            onClick={this.handleSendOtp}
          >
            {resendCountdown > 0
              ? `Resend OTP in ${resendCountdown}s`
              : "Resend OTP"}
          </Button>
        </>
      );
    }
  
    renderRegulatoryBanner() {
      const { regulatoryAccepted } = this.state;
  
      return (
        <Box
          sx={{
            bgcolor: "#fef7e0",
            border: "1px solid #f5d77a",
            borderRadius: 2,
            p: 2,
            mb: 3,
          }}
        >
          <Typography variant="caption" color="text.secondary">
            <strong>Regulatory Notice:</strong> This system is monitored and audited.
            Unauthorized access is prohibited and may be prosecuted under applicable
            laws and regulations. By proceeding, you acknowledge compliance with
            data protection, cybersecurity, and usage policies.
          </Typography>
  
          <Button
            fullWidth
            size="small"
            sx={{ mt: 1 }}
            variant={regulatoryAccepted ? "contained" : "outlined"}
            onClick={() => this.setState({ regulatoryAccepted: true })}
          >
            {regulatoryAccepted ? "Acknowledged" : "Acknowledge & Continue"}
          </Button>
        </Box>
      );
    }
  
    render() {
      const { step } = this.state;
  
      return (
        <Box sx={{...s.formbox}}>
          <Card sx={{ width: 400, boxShadow: 0, borderRadius: '0 15px 15px 0' }}>
            <CardContent sx={{ p: 4 }}>
              <Box sx={{ display: 'flex',flexDirection:'row',alignItems:'center', justifyContent: 'center', mt:3}}>
                <img src="/lib/img/logo.png" alt="Logo" style={{ width:40,height:'100%' }} />
                <Typography variant="h6" sx={{textAlign:'center' }}>
                  The Church of Pentecost
                </Typography>
              </Box>
              <Typography variant="body2" sx={{textAlign:'center',mb: 3, }}>
                  Pantang Assembly
                </Typography>
              <Typography
                variant="h5"
                textAlign="center"
                fontWeight={600}
                mb={1}
              >
                Secure Access
              </Typography>
  
              <Typography
                variant="body2"
                textAlign="center"
                color="text.secondary"
                mb={3}
              >
                Multi-factor authentication required
              </Typography>
  
              {step === "CREDENTIALS" && this.renderCredentials()}
              {step === "OTP_SELECT" && this.renderOtpSelector()}
              {step === "OTP_VERIFY" && this.renderOtpVerify()}
            </CardContent>
          </Card>
        </Box>
      );
    }
}

export default MFALoginForm;
